import { getClientsTradingHistory, getClientsAccountTotals } from "../../utils/apiClient";

/**
 * Fetch per-client trading volume for a date range.
 * TOTAL_VOLUME is the sum of all trading-account volumes for that client.
 */
export const fetchClientsTradingHistory = async ({
  dateFrom,
  dateTo,
  options = {},
} = {}) => {
  const response = await getClientsTradingHistory(dateFrom, dateTo, options);

  if (response && response.decryptedData) {
    return response.decryptedData;
  }

  if (response && response.data) {
    return response.data;
  }

  return response;
};

/**
 * Fetch current per-client total balance and equity.
 */
export const fetchClientsAccountTotals = async ({ options = {} } = {}) => {
  const response = await getClientsAccountTotals(options);

  if (response && response.decryptedData) {
    return response.decryptedData;
  }

  if (response && response.data) {
    return response.data;
  }

  return response;
};

export default {
  fetchClientsTradingHistory,
  fetchClientsAccountTotals,
};
